import { AnyObject, API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  sectionId: string;
  updates: AnyObject;
};

const [useUpdateSection, updateSection] = createAsyncAction(
  "sections/update",
  async ({ sectionId, updates }: Args) => {
    const res = await API.call<{ section: string }>({
      endpoint: `/sections/${sectionId}`,
      method: "PUT",
      data: updates,
    });
    return { ...res, result: res.result.section };
  }
);

export default useUpdateSection;
export { updateSection };
